<template>
  <div>
    <Nav />
    <!-- 主要内容区 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="approve" />
      <main class="flex-1 p-6">
        <div class="">
          <div class="mb-8">
            <h1 class="text-2xl font-bold text-gray-900">认证分销伙伴</h1>
            <p class="text-gray-600 mt-1">
              成为分销伙伴，提升您的销售能力和客户服务水平
            </p>
          </div>
          <!-- <div class="bg-white rounded-xl shadow-sm p-8">
            暂未开放，敬请期待！
          </div> -->
          <div class="bg-white rounded-xl shadow-sm p-8">
            <div class="">
              <div class="form-title">
                <h3>基本信息</h3>
                <p class="form-subtitle">请填写真实信息，用于分销伙伴认证</p>
              </div>

              <!-- 已认证时显示只读基本信息 -->
              <div v-if="isApproved" class="form-content">
                <div class="info-display">
                  <div class="info-item">
                    <span class="info-label">真实姓名：</span>
                    <span class="info-value">{{ formData.realname }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">手机号码：</span>
                    <span class="info-value">{{ formData.mobile }}</span>
                  </div>
                  <div class="info-item" v-if="formData.idcard">
                    <span class="info-label">身份证号：</span>
                    <span class="info-value">{{ formData.idcard }}</span>
                  </div>
                  <div class="info-item" v-if="formData.company">
                    <span class="info-label">公司名称：</span>
                    <span class="info-value">{{ formData.company }}</span>
                  </div>
                  <div class="info-item" v-if="formData.industry">
                    <span class="info-label">行业类型：</span>
                    <span class="info-value">{{ getIndustryLabel(formData.industry) }}</span>
                  </div>
                  <div class="info-item" v-if="formData.email">
                    <span class="info-label">联系邮箱：</span>
                    <span class="info-value">{{ formData.email }}</span>
                  </div>
                </div>
              </div>

              <!-- 未认证时显示表单 -->
              <el-form
                v-else
                ref="approveForm"
                :model="formData"
                :rules="rules"
                label-width="120px"
                class="form-content"
              >
                <el-form-item label="真实姓名" prop="realname">
                  <el-input
                    v-model="formData.realname"
                    placeholder="请输入您的真实姓名"
                    maxlength="20"
                    show-word-limit
                  ></el-input>
                </el-form-item>

                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    v-model="formData.mobile"
                    placeholder="请输入您的手机号码"
                    maxlength="11"
                    show-word-limit
                    onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="身份证号"
                  prop="idcard"
                  class="optional-field"
                >
                  <el-input
                    v-model="formData.idcard"
                    placeholder="请输入您的身份证号码（选填）"
                    maxlength="18"
                    show-word-limit
                  ></el-input>
                  <div class="field-tip">提供身份证信息可提高认证成功率</div>
                </el-form-item>

                <el-form-item
                  label="公司名称"
                  prop="company"
                  class="optional-field"
                >
                  <el-input
                    v-model="formData.company"
                    placeholder="请输入您的公司名称（选填）"
                    maxlength="50"
                    show-word-limit
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="行业类型"
                  prop="industry"
                  class="optional-field"
                >
                  <el-select
                    v-model="formData.industry"
                    placeholder="请选择您所在的行业（选填）"
                    class="w-80"
                  >
                    <el-option label="摄影摄像" value="photography"></el-option>
                    <el-option label="活动策划" value="event"></el-option>
                    <el-option label="婚礼服务" value="wedding"></el-option>
                    <el-option label="影视制作" value="film"></el-option>
                    <el-option label="广告传媒" value="advertising"></el-option>
                    <el-option label="教育培训" value="education"></el-option>
                    <el-option label="其他行业" value="other"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="联系邮箱"
                  prop="email"
                  class="optional-field"
                >
                  <el-input
                    v-model="formData.email"
                    placeholder="请输入您的联系邮箱（选填）"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </el-form-item>

                <el-form-item class="submit-button">
                  <el-button
                    type="primary"
                    @click="submitForm"
                    :loading="submitting"
                  >
                    {{ submitting ? "提交中..." : "提交认证" }}
                  </el-button>
                  <el-button @click="resetForm">重置</el-button>
                </el-form-item>
              </el-form>

              <div class="approve-tips">
                <h4>认证说明：</h4>
                <ul>
                  <li>1. 提交认证后，我们将在1-3个工作日内完成审核</li>
                  <li>2. 认证成功后，您将获得分销伙伴资格和相应权限</li>
                  <li>
                    3. 请确保提供的信息真实有效，虚假信息将影响您的认证结果
                  </li>
                  <li>4. 如有疑问，请联系客服热线：010-84855667</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import LeftNav from "@/components/LeftNav.vue";
import Footer from "@/components/Footer.vue";
import { Message } from "element-ui";
import api from "@/utils/api.js";

export default {
  name: "Approve",
  components: {
    Nav,
    LeftNav,
    Footer,
  },
  data() {
    return {
      submitting: false,
      distributor: {},
      isApproved: false, // 标记用户是否已认证
      formData: {
        realname: "",
        mobile: "",
        idcard: "",
        company: "",
        industry: "",
        email: "",
      },
      rules: {
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z\s·]+$/,
            message: "请输入有效的姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        idcard: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入有效的身份证号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "请输入有效的邮箱地址",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // 检查用户是否已认证
    this.checkApprovalStatus();
  },
  methods: {
    // 检查用户认证状态
    async checkApprovalStatus() {
      try {
        const response = await api.user.checkApprovalStatus();
        if (response.data) {
          this.formData = response.data;
          this.isApproved = true; // 用户已认证
        }
      } catch (error) {
        console.error("检查认证状态失败:", error);
      }
    },

    // 提交表单
    async submitForm() {
      // 验证表单
      const valid = await this.$refs.approveForm.validate();
      if (!valid) {
        Message.warning("请完善必填信息");
        return false;
      }

      this.submitting = true;
      try {
        // 构建提交数据
        const submitData = {
          realname: this.formData.realname,
          mobile: this.formData.mobile,
          idcard: this.formData.idcard,
          company: this.formData.company,
          industry: this.formData.industry,
          email: this.formData.email,
        };

        // 调用API提交认证信息
        const response = await api.user.approveSend(submitData);
        if (response.code === 200) {
          this.$router.push("/ucenter/index");
        }
      } catch (error) {
        console.error("提交认证失败:", error);
        this.submitting = false;
      } finally {
        this.submitting = false;
      }
    },

    // 获取行业类型显示名称
    getIndustryLabel(industryValue) {
      const industryMap = {
        'photography': '摄影摄像',
        'event': '活动策划',
        'wedding': '婚礼服务',
        'film': '影视制作',
        'advertising': '广告传媒',
        'education': '教育培训',
        'other': '其他行业'
      };
      return industryMap[industryValue] || industryValue;
    },

    // 重置表单
    resetForm() {
      this.$refs.approveForm.resetFields();
    },
  },
};
</script>

<style scoped>
.approve-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  padding: 20px;
  background-color: #f5f7fa;
}

.header {
  margin-bottom: 20px;
}

.header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.approve-form-container {
  max-width: 800px;
  margin: 0 auto;
}

.approve-form {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

.form-title {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.form-title h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.form-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.form-content {
  margin-bottom: 24px;
}

/* 信息展示样式 */
.info-display {
  padding: 20px 0;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-label {
  width: 120px;
  color: #606266;
  font-size: 14px;
  text-align: right;
  margin-right: 20px;
}

.info-value {
  flex: 1;
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}

.optional-field .el-form-item__label::after {
  content: "(选填)";
  color: #9ca3af;
  font-size: 12px;
  font-weight: normal;
  margin-left: 4px;
}

.field-tip {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

.agreement {
  margin-top: 10px;
  margin-bottom: 20px;
}

.agreement a {
  text-decoration: underline;
}

.submit-button {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.submit-button .el-button {
  min-width: 120px;
  margin: 0 8px;
}

.approve-tips {
  margin-top: 24px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 6px;
  border-left: 4px solid #409eff;
}

.approve-tips h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
}

.approve-tips ul {
  padding-left: 20px;
}

.approve-tips li {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content {
    padding: 15px;
  }

  .approve-form {
    padding: 20px;
  }

  .el-form-item__label {
    width: 100px !important;
    font-size: 14px;
  }

  .el-form-item__content {
    margin-left: 110px !important;
  }
}

@media (max-width: 480px) {
  .el-form--label-left .el-form-item__label {
    text-align: left;
    float: none;
    width: 100% !important;
    margin-bottom: 8px;
  }

  .el-form--label-left .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/Approve.vue